import { ArrowLeft, Award, ChevronDown, School, Sparkles, Trophy } from 'lucide-react';
import { Link } from 'react-router-dom';
import class12Results2025 from '../data/class12Results2025.json';
import '../styles/Class10Results2025.css';

const rankedResults = [...class12Results2025].sort(
  (left, right) => right.percentage - left.percentage || left.fullName.localeCompare(right.fullName),
);

function MathsScore({ student }) {
  return (
    <div className="class12-maths-score" aria-label={`Maths score ${student.percentage} percent`}>
      <span>Maths score</span>
      <strong>{student.percentage}<small>%</small></strong>
    </div>
  );
}

function StudentCard({ student, rank }) {
  return (
    <article className="class10-student-card class12-student-card">
      <span className="class10-card-rank" aria-label={`Rank ${rank}`}>{String(rank).padStart(2, '0')}</span>
      <div className="class10-card-profile">
        <img src={student.passportImage} alt={`${student.fullName} passport`} className="class10-card-photo" loading="lazy" decoding="async" />
        <div className="class10-card-copy">
          <h3>{student.fullName}</h3>
          <p><School size={15} /><span>{student.schoolName}</span></p>
        </div>
      </div>
      <MathsScore student={student} />
    </article>
  );
}

function FeaturedStudent({ student, rank }) {
  return (
    <article className={`class10-featured-card class10-featured-card-${rank} class12-featured-card`}>
      <div className="class10-featured-topline">
        <span>#{String(rank).padStart(2, '0')}</span>
        {rank === 1 && <Trophy size={19} aria-label="Top rank" />}
      </div>
      <img src={student.passportImage} alt={`${student.fullName} passport`} className="class10-featured-photo" />
      <div className="class10-featured-copy">
        <p className="class10-featured-eyebrow">{rank === 1 ? 'Highest achiever' : 'Top performer'}</p>
        <h3>{student.fullName}</h3>
        <p className="class10-featured-school">{student.schoolName}</p>
      </div>
      <MathsScore student={student} />
    </article>
  );
}

function Class12Results2025() {
  const [firstPlace, secondPlace, thirdPlace] = rankedResults;
  const remainingResults = rankedResults.slice(3);

  return (
    <main className="class10-results-page class12-results-page">
      <section className="class10-results-hero">
        <div className="class10-hero-orb class10-hero-orb-one" />
        <div className="class10-hero-orb class10-hero-orb-two" />
        <div className="class10-hero-inner">
          <Link to="/" className="class10-back-link"><ArrowLeft size={16} /> Back to home</Link>
          <div className="class10-hero-content">
            <div>
              <p className="class10-kicker"><Sparkles size={16} /> Celebration of excellence</p>
              <h1>Class 12th<br /><em>2025-26 Toppers</em></h1>
              <p className="class10-hero-description">Celebrating our Class 12 achievers and the dedication behind their outstanding results.</p>
            </div>
          </div>
          <div className="class10-result-seal"><Award size={25} /><strong>90%</strong><span>Top score</span></div>
          <div className="class10-hero-footer">
            <a href="#honour-roll">Explore toppers <ChevronDown size={17} /></a>
          </div>
        </div>
      </section>

      <section className="class10-spotlight" aria-labelledby="spotlight-title">
        <div className="class10-section-intro">
          <p>Spotlight</p><h2 id="spotlight-title">Leading the way</h2>
        </div>
        <div className="class10-featured-grid">
          <FeaturedStudent student={secondPlace} rank={2} />
          <FeaturedStudent student={firstPlace} rank={1} />
          <FeaturedStudent student={thirdPlace} rank={3} />
        </div>
      </section>

      <section id="honour-roll" className="class10-honour-roll" aria-label="All Class 12th toppers">
        <div className="class10-results-grid">
          {remainingResults.map((student, index) => <StudentCard key={student.id} student={student} rank={index + 4} />)}
        </div>
      </section>
    </main>
  );
}

export default Class12Results2025;
